import { createSlice } from '@reduxjs/toolkit';

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    data: [],
  },
  reducers: {
    setSubscriptionss(state, action) {
      state.data = action.payload;
    },
    clearSubscriptions(state) {
      state.data = [];
    },
  },
});

export const { setSubscriptionss, clearSubscriptions } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;